import React from 'react';
import { copyToClipboard } from './popupUtils';
import { toast } from 'react-toastify';

const PopupAliasListItem = ({ alias, onEdit }) => {
    const handleCopy = (e) => {
        copyToClipboard(`${alias.alias}@nslmail.com`, toast.success);
        // Select all text when clicked
        if (e.target.select) {
            e.target.select();
        }
    };

    return (
        <div className="popup-alias-item">
            <div className="popup-alias-item-header">
                <div className="popup-alias-item-content">
                    <div className="popup-alias-item-site-name">
                        Site Name: {alias.site_name}
                    </div>
                    <div className="popup-alias-item-row">
                        <span>Alias:</span>
                        <input 
                            type="text" 
                            value={`${alias.alias}@nslmail.com`}
                            readOnly
                            onClick={handleCopy}
                            className="popup-read-only-field"
                            style={{
                                cursor: 'pointer',
                                userSelect: 'all',
                                width: '180px'
                            }}
                            title="Click to copy to clipboard"
                        />
                        <button 
                            onClick={() => onEdit(alias)}
                            className="popup-small-button"
                            title="Edit alias"
                        >
                            Edit
                        </button>
                    </div>
                    {alias.private_notes && alias.private_notes.trim() && (
                        <div style={{ 
                            marginTop: 'var(--space-2)', 
                            fontSize: 'var(--font-size-sm)', 
                            color: 'var(--gray-600)',
                            paddingLeft: 'var(--space-3)',
                            paddingTop: 'var(--space-2)',
                            paddingBottom: 'var(--space-2)',
                            whiteSpace: 'pre-line',
                            borderLeft: '3px solid var(--primary-200)',
                            backgroundColor: 'var(--gray-50)',
                            borderRadius: '0 var(--radius-sm) var(--radius-sm) 0',
                            marginLeft: '0'
                        }}>
                            {alias.private_notes}
                        </div>
                    )}
                </div>
                <div className="popup-alias-item-stats">
                    <div className="popup-alias-item-stat-row">
                        <img src="/images/messages.jpg" alt="Messages" className="popup-alias-item-stat-icon" />
                        <span>{alias.message_count || 0}</span>
                    </div>
                    <div className="popup-alias-item-stat-row-margin-top">
                        <img src="/images/blacklist.gif" alt="Blocked" className="popup-alias-item-stat-icon" />
                        <span>{alias.spam_count || 0}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupAliasListItem;